const difficulty = {
  description: {
    1: 'More Moves',
    2: 'Just right',
    3: 'Less moves'
  },
  level: {
    1: { 1: 30, 2: 45, 3: 60 },
    2: { 1: 25, 2: 40, 3: 60 },
    3: { 1: 20, 2: 35, 3: 50 }
  }
};

export default difficulty;



// WEBPACK FOOTER //
// ./src/Game/difficulty.js